export default "__VITE_ASSET__DM9_uFXl__"